import type { MixedDressingDetails } from '@sg/graphql-schema';

import type { Modification } from '../../types';
import { getDressingPortionSize } from './get-dressing-portion-size';

// ─────────────────────────────────────────────────────────────────────────────

export function calculateMixedDressingCalories(
  modification: Modification,
  mixedDressingDetails: MixedDressingDetails[],
) {
  const { ingredient } = modification;

  if (!ingredient) {
    return 0;
  }

  const portionSize = getDressingPortionSize(modification, mixedDressingDetails); // prettier-ignore
  const ingredientCalories = ingredient.calories ?? 0;

  return ingredientCalories * portionSize;
}
